import * as React from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { ModalProvider } from '../Modal';
import themes from './themes';

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: themes[theme || 'win95']
  }, /*#__PURE__*/React.createElement(ModalProvider, null, children));
};

ThemeProvider.defaultProps = {
  theme: 'win95'
};
export default ThemeProvider;